import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { InfoTableConfig } from '../shared.interface';
@Component({
    selector: 'app-info-table',
    templateUrl: './info-table.component.html',
    styleUrls: ['./info-table.component.scss'],
})
export class InfoTableComponent implements OnInit {
    @Input() tableData: InfoTableConfig;

    originalOrder = (
        a: KeyValue<number, string>,
        b: KeyValue<number, string>
    ): number => {
        return 0;
    };

    constructor() {}

    ngOnInit(): void {}
}
